import { connect } from 'react-redux';
import { getErrorMessage } from 'src/store/error/selectors';
import { selectIsError } from 'src/store/popup/selectors';
import { selectOrderID } from '../../../store/payment/selectors';
import CertificateErrorPopup from '../components/CertificateErrorPopup';
import { goToOrderAction } from '../store/view/sagaActions';
import { hideErrorPopup } from '../store/view/slice';

const mapStateToProps = (state) => ({
  isOpen: selectIsError(state),
  orderId: selectOrderID(state),
  errorMessage: getErrorMessage(state),
});

const mapDispatchToProps = {
  onClose: hideErrorPopup,
  goToOrder: goToOrderAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CertificateErrorPopup);
